
<template>
  <div>
    <div class="paygrpsDiv"> 
      <div class="alignPaygrp">
        <span>Selected Employees</span>
        <br />
        <div class="paygrps-info">
          <b>{{ offPayrollSelectedEmployees}}</b>
        </div>
      </div>
      <div class="alignPaygrp">
        <span>Varaible Earnings</span>
        <br />
        <div class="paygrps-info">
          <b>{{ offPayrollVariableEarnings }}</b>
        </div>
      </div>
      <div class="alignPaygrp">
        <span>Varaible Deductions</span>
        <br />
        <div class="paygrps-info">
          <b>{{ offPayrollVariableDeductions }}</b>
        </div>
      </div>
    </div>
    <div class="d-payroll__group">
      <div class="d-heading2 d-marginBottom d-flexbox">Add Variable Earnings and Deductions</div>
    </div>
    <div class="uploadMethoRadio">
      <tl-radio
        name="uploadMethod"
        label="Bulk Upload"
        id="bulkUpload"
        value="bulkUpload"
        v-model="uploadMethod"
      />

      <tl-radio
        name="uploadMethod"
        label="Manual"
        id="manualUpload"
        value="manualUpload"
        v-model="uploadMethod"
      />
    </div>

    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <div v-if="uploadMethod === 'bulkUpload'">
      <div class="download-btn">
        <!-- <download-button
          onclick="location.href='https://dev-opn-test1.s3.ap-south-1.amazonaws.com/paylief-bulk-upload-templates/Template-+One+time+payment+and+deduction.xlsx'"
        ></download-button> -->
          <download-button class="downloadTemplateButton" @downloadTemplate="getEmployeeTemplate()"></download-button>    
      </div>
      <div class="margintop-20 margin-bottom-50" :key="componentKey">
        <!-- <upload-file @uploadTemplate="onUploadTemplate($event)" /> -->
        <!-- <upload-file :apiUrl="bulkUploadUrl" @uploadTemplate="onUploadTemplate($event)" /> -->
        <upload :tobucket="false" ref="bulkFile" @change="onUploadTemplate($event)"></upload>
      </div>
    </div>
    <div v-else>
      <div class="margin-top-30">
        <div>
        <tl-select
            label="Select Employee"
            placeholder="Select"
            labelText="empCode"
            :value="employee"
            :options="employeeData"
            @change="(val)=>{employee= val.empCode ; setEmployee(val)}"
          />
      </div>
        <div class="customGrid2 margin-top-20">
          <div>
            <tl-select
              label="Select Component *"
              name="salaryComponent"
              :options="componentsList"
              labelText="name"
              v-model="formData.componentObj"
              @change="(val) => changeComponent(val)"
              :multiple="false"
              data-vv-as="Salary Component"
              v-validate="{required: true}"
              :classname="errors.has('salaryComponent')"
              :errormsg="errors.first('salaryComponent')"
            />
          </div>
          <div class="noofdays">
            <txt
              label="Enter Amount *"
              name="amount"
              class="custom-width"
              type="number"
              v-model="formData.amount"
              v-numeric-only
              data-vv-as="Amount"
              v-validate="{required: true, max: 9}"
              :classname="errors.has('amount')"
              :errormsg="errors.first('amount')"
            ></txt>
          </div>
        </div>
      </div>

      <br />
      <div class="margin-top-30">
        <btn text="Add " type="secondary" @click="add" />
      </div>
    </div>
    <div class="lock-list">
      <tl-checkbox label="Lock Earnings and Deductions List" @change="(bool)=>{locklist(bool)}"></tl-checkbox>
    </div>
    <pop-up-message
      v-if="showErrorPopup"
      message=""
      popupType="Warning"
      :popupHeaderMessage="'UPLOAD FAILED!!!'"

    >
        <template v-slot:bottomContent>
        <div class=" margintop-32">
          <div class="Rectangle margintop-32">
          <span class="Information-message">{{ logMessage }}</span>
          </div>
          <!-- <div class=" margintop-32">
            <span>{{successCount}} Employee records inserted. </span>
            </div>
            <div class=" margintop-32">
            <span>{{invalidCount}} records had incorrect data
               </span>
               <span>(Error records will be ignored. You can continue with rest of the file)</span>
          </div>
          <div class="radio-btn margintop-32">
            <span>{{existingCount}} records already exist. </span>
       <tl-radio
          name="checkAction"
          label="overwrite"
          id="overwrite"
          value="overwrite"
          v-model="flag"
        />
        <tl-radio
          name="checkAction"
          label="skip"
          id="skip"
          value="skip"
          v-model="flag"
        
        </div> -->
    </div>
    <div class="margintop-32 custom-container">
    <a :href="logSheetUrl"
      @click="downloadItem(logSheetUrl)"
    ><img src="@/assets/download.svg"  class="img" /> <span class="text">Error Log Sheet</span></a>
        </div>

        <div class="popup-btn-group margintop-32 marginright">

          <button class="btn-popup" type="button" @click="backfromlogpopup()">Back To Earning & Deductions</button>

         <!-- <button class="btn-popup" type="button" @click="uploadFile2($event)">Proceed</button>
              -->  </div>
      </template>
    </pop-up-message>

    <footer>
      <bottom-action-container>
        <btn-skip @navClicked="skip" />
        <template slot="end">
          <btn-grp class="form-button">
            <btn text="Cancel" type="secondary" @click="cancel" />
            <btn text="Next" type="primary" :disabled="!isLocked" @click="save" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </footer>

    <pop-up-message
      v-if="showBulkUploadSuccessMsg"
      :message="`${popupMessage}`"
      btnText="Back"
      @back="back"
    ></pop-up-message>

    <pop-up-message
      v-if="showSuccessMsg"
      :message="popupMsg"
      btnText="Back"
      @back="backfrompopup()"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import { throws } from "assert";
import { api_variables } from "@/apis/variables.js";

export default {
  name: "VariableEarnings",
  components: { SearchDropdown },
  data() {
    return {
      bulkUploadUrl: api_variables.SERVICE_PAYMENT_DEDUCTION_UPLOAD_TEMPLATE,
      errmsg: "",
      toast: false,
      showSuccessMsg: "",
      popupMsg: "",

      popupMessage: "",
      showBulkUploadSuccessMsg: false,

      formData: {
        amount: null,
        month: "",
        componentObj: null,
        actionObj: null,
        yearObj: null,
        monthObj: null
      },

      countObj: {
        payGroupsSelected: 0,
        totalEmployeesSelected: 0,
        eligibleEmployeesSelected: 0,

        totalPayGroups: 0,
        totalEmployees: 0,
        totalEligibleEmployees: 0
      },

      searchText: "",
      componentsList: [],
      selectedEmpData: null,
      uploadMethod: "manualUpload",
      isLocked: false,
      month: "",
      component: "",
      empName: "",
      empId: "",
      amount: "",
      employeeData: [],
      allMonthsArray: [
        { name: "January", id: "jan" },
        { name: "February", id: "feb" },
        { name: "March", id: "mar" },
        { name: "April", id: "apr" },
        { name: "May", id: "may" },
        { name: "June", id: "jun" },
        { name: "July", id: "jul" },
        { name: "August", id: "aug" },
        { name: "September", id: "sep" },
        { name: "October", id: "oct" },
        { name: "November", id: "nov" },
        { name: "December", id: "dec" }
      ],
      yearsListArray: [],
      employeeSalaryComponents: [],
      showErrorPopup:false,
      logSheetUrl: null,
      logMessage: null,
      componentKey: 0,
      ss_id: null,
      employee: "",
      offPayrollSelectedEmployees: 0,
      offPayrollVariableEarnings: 0,
      offPayrollVariableDeductions: 0
    };
  },
  activated() {
    this.uploadMethod = "manualUpload";
    this.$validator.reset();
    this.refresh();
    this.setData();
    this.getMonths();
      if(this.le_id == this.selectedEmployeesList[0].le_id){
        this.employeeData = this.selectedEmployeesList[0].employees
    }
    this.fetchOffPayrollSummaryData();
  },
  mounted() {
      if(this.le_id == this.selectedEmployeesList[0].le_id){
        this.employeeData = this.selectedEmployeesList[0].employees
    }
    this.fetchOffPayrollSummaryData();
  },
  beforeDestroy() {
    this.refresh();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState({
      employeesJoiningsData: state => state.payroll.joinings.joinings, //fetch employees data
      selectedPayGroupsData: state => state.payroll.paygroups.data,
      payGroupsData: state => state.payroll.paygroups.payGroups,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },

    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    ...mapState({
        selectedEmployeesList: state => state.payroll.selectedemployee.employeeDataForOffCycle,
    }),
  },
  methods: {
    ...mapActions({
      act_create: "payroll/variableearnings/create",
      act_fetchAllSalaryComponents:
        "onboard/settings/salary_component/fetchAll",
      act_upload_template: "payroll/variableearnings/fileuploadTemplate",
      act_employee_salary_components:
        "payroll/variableearnings/fetchEmployeeSalaryComponents",
      fetchEmployeeByLeNameCode:
        "globalapi/globalemployees/fetchByLeAndName", //PL_3029
      act_upload_template_new: "payroll/variableearnings/fileuploadTemplateNew",
      fetch_template: "payroll/variableearnings/getEmployeeTemplate",
      act_fetchSalaryStructureComponent: "onboard/settings/salary_structure/fetchSalaryStructureComponents",
      act_get_off_payroll_summary: "payroll/selectedemployee/createSummaryData"
    }),

    // PL_3029
    async searchEmployeeByNameCode(val) {
      try {
        let res = await this.fetchEmployeeByLeNameCode({
          le_id: this.le_id,
          key: val
        });
        if (res.data.status) {
          this.employeeData = res.data.payload;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    // PL_3029

    skip() {
      this.refresh();

      this.$router.push({
        path: `/payroll/run/${this.$route.params.entity_index}/tdsForOffPayroll`
      });
    },

    getMonths() {
      try {
        var today = new Date();
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = today.getFullYear();

        let currentYear = yyyy;
        let nextYear = yyyy + 1;
        this.yearsListArray = [
          { name: String(currentYear), id: currentYear },
          { name: String(nextYear), id: nextYear }
        ];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** Function to set the counts of different elements in UI */
    setData() {
      try {
        let payGroupsData = this.payGroupsData[this.le_id];
        let selectedPayGroupsData = this.selectedPayGroupsData[this.le_id];

        if (payGroupsData) {
          this.countObj.totalPayGroups = payGroupsData.length;

          let totalEmployees = 0;
          let totalEligibleEmployees = 0;

          payGroupsData.forEach(item => {
            totalEmployees =
              totalEmployees + (item.totalEmployess ? item.totalEmployess : 0);
            totalEligibleEmployees =
              totalEligibleEmployees +
              (item.eligibleEmployees ? item.eligibleEmployees : 0);
          });

          this.countObj.totalEmployees = totalEmployees;
          this.countObj.totalEligibleEmployees = totalEligibleEmployees;
        }

        if (selectedPayGroupsData) {
          this.countObj.payGroupsSelected = selectedPayGroupsData.length;

          let totalEmployeesSelected = 0;
          let eligibleEmployeesSelected = 0;

          selectedPayGroupsData.forEach(item => {
            totalEmployeesSelected =
              totalEmployeesSelected +
              (item.totalEmployess ? item.totalEmployess : 0);
            eligibleEmployeesSelected =
              eligibleEmployeesSelected +
              (item.eligibleEmployees ? item.eligibleEmployees : 0);
          });

          this.countObj.totalEmployeesSelected = totalEmployeesSelected;
          this.countObj.eligibleEmployeesSelected = eligibleEmployeesSelected;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async fetchOffPayrollSummaryData() {
      try {
        let employeeIds = []
        this.employeeData.map(element => {
          employeeIds.push(element.empId);
        })
        let data = {
          le_id: this.le_id,
          processing_payroll_month: this.getSelectedMonthEnumByName(
            this.payrollMonth
          ),
          financial_year: this.payrollYear,
          employeeIds:  employeeIds
        };
        let res = await this.act_get_off_payroll_summary({data});
        if (res.data.status) {
          this.offPayrollSelectedEmployees = res.data.payload.totalHeadCount;
          this.offPayrollVariableDeductions = res.data.payload.variableEarnings;
          this.offPayrollVariableEarnings = res.data.payload.variableDeductions;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** On click of clear in search bar */
    employeeCleared() {
      this.selectedEmpData = null;
      this.employeeSalaryComponents = [];
      this.formData.componentObj = null;
      this.formData.amount = null;
    },
    /** On click of selected employee in search bar */
    selectedEmp(val) {
      this.selectedEmpData = val;
      this.getEmployeesSalaryComponents(val.id);
    },
    /** Function to fetch the selected employee Salary components list data from server */
    async getEmployeesSalaryComponents(empId) {
      try {
        let res = await this.act_employee_salary_components(empId);
        this.ss_id = res.data.payload.data.salary_structure_id;
        this.employeeSalaryComponents =
          res.data.payload.data.master_salary_structure;
        this.fetchSalaryComponents();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** On Salary component drop down selection */
    changeComponent(val) {
      try {
        if (val) {
          this.formData.componentObj = val;
        } else {
          this.formData.componentObj = null;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to fetch all the Salary components of a LE id */
    async fetchSalaryComponents() {
      try {
        let res = await this.act_fetchSalaryStructureComponent({id: this.ss_id,
          leId: this.le_id});
        let dataArr = res.data.payload[0].sssc;
        this.componentsList = [];
        if (dataArr.length) {
          dataArr.forEach(item => {
            // if (
            //   (item.transaction_type == "EARNING" && item.transaction_type == "DEDUCTION")
            //   // ||
            //   // (item.part_of_ctc == true &&
            //   //   item.ctcSubSection == "Variable" &&
            //     // this.employeeSalaryComponents.some(
            //     //   salaryComponent => salaryComponent.code == item.code
            //     // ))
            // ) {

            //   this.componentsList.push(item);
            // }
            if((item.transaction_type == "EARNING" || item.transaction_type == "DEDUCTION") && item.selected){
              this.componentsList.push(item);
            }
          });
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to refresh the form data */
    refresh() {
      try {
        this.formData = {
          amount: null,
          month: "",
          componentObj: null,
          actionObj: null,
          yearObj: null,
          monthObj: null,
        };
        this.employee = null;

        this.month = "";
        this.component = "";
        this.amount = "";
        this.toast = false;
        this.errmsg = "";
        this.selectedEmpData = null;

        this.employeeSalaryComponents = [];
        this.componentsList = [];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to validate before adding a employee for TDS */
    async add() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction("add");
        }
      });
    },
    /** Function to submit the form data to server */
    async performAction(type) {
      
      try {
        if (!this.isLocked) {
          if (!this.selectedEmpData) {
            this.toast = true;
            this.errmsg = "Please select an employee";
            return;
          } else if (!this.selectedEmpData.empId) {
            this.toast = true;
            this.errmsg = "Please select an employee";
            return;
          } else {
            //this.toast = true; not used
           // this.errmsg = "";
          }

          let month = this.formData.month;

          var splits = month.split("-");
          let selectedMonthEnum = "";

          if (splits.length) {
            let selectedMonth = splits[1];
            selectedMonthEnum = this.getSelectedMonthEnum(selectedMonth);
          }

          var today = new Date();
          var dd = String(today.getDate()).padStart(2, "0");
          var mm = String(today.getMonth() + 1).padStart(2, "0");
          var yyyy = today.getFullYear();
          today = dd + "-" + mm + "-" + yyyy;

          let obj = {
            data: {
              employee_id: this.selectedEmpData
                ? this.selectedEmpData.empId
                : null,
              financial_year: this.payrollYear,
              code: this.formData.componentObj
                ? this.formData.componentObj.code
                : null,
              salary_component_id: this.formData.componentObj
                ? this.formData.componentObj.id
                : null,
              name: this.formData.componentObj
                ? this.formData.componentObj.name
                : null,
              value: this.formData.amount,
              assigned_date: today,
              processing_month: this.getSelectedMonthEnumByName(
                this.payrollMonth
              ), //selectedMonthEnum,
              status: "INPUT", // enum type - values : ['INPUT', 'PROCESSED'],
              transaction_type: this.formData.componentObj
                ? this.formData.componentObj.transaction_type
                : null
            }
          };

          try {
            this.$root._data.isSaving = true;
            let res = await this.act_create(obj.data);
            setTimeout(() => {
              if (res.status == 200 || res.status == 201) {
                if (type == "next") {
                    this.$router.push({
                    path: `/payroll/run/${this.$route.params.entity_index}/tdsForOffPayroll`,
                  });
                } else {
                  this.showSuccessMsg = true;
                  this.popupMsg = res.data.message;
                }

                this.refresh();
                this.fetchOffPayrollSummaryData();
              }
              this.$root._data.isSaving = false;
            }, 500);
          } catch (err) {
            this.$root._data.isSaving = false;
            this.toast = true;
            this.errmsg = err;
          }
          //}
        } else {
            this.$router.push({
              path: `/payroll/run/${this.$route.params.entity_index}/tdsForOffPayroll`,
            });
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    backfrompopup() {
      this.showSuccessMsg = false;
    },

    backfromlogpopup(){
      this.showErrorPopup = false;
      this.componentKey += 1;
    },
    /** Function to get the selected month enum by Name*/
    getSelectedMonthEnumByName(selectedMonth) {
      try {
        let selectedMonthEnum = "";
        switch (selectedMonth) {
          case "January":
            selectedMonthEnum = "jan";
            break;
          case "February":
            selectedMonthEnum = "feb";
            break;
          case "March":
            selectedMonthEnum = "mar";
            break;
          case "April":
            selectedMonthEnum = "apr";
            break;
          case "May":
            selectedMonthEnum = "may";
            break;
          case "June":
            selectedMonthEnum = "jun";
            break;
          case "July":
            selectedMonthEnum = "jul";
            break;
          case "August":
            selectedMonthEnum = "aug";
            break;
          case "September":
            selectedMonthEnum = "sep";
            break;
          case "October":
            selectedMonthEnum = "oct";
            break;
          case "November":
            selectedMonthEnum = "nov";
            break;
          case "December":
            selectedMonthEnum = "dec";
            break;

          default:
            break;
        }
        return selectedMonthEnum; // Enum type - values :  ['jan', 'feb','mar', 'apr','may', 'jun','jul', 'aug','sep', 'oct','nov', 'dec']
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to get the selected month enum by Name*/
    getSelectedMonthEnum(selectedMonth) {
      try {
        let selectedMonthEnum = "";
        switch (selectedMonth) {
          case "01":
            selectedMonthEnum = "jan";
            break;
          case "02":
            selectedMonthEnum = "feb";
            break;
          case "03":
            selectedMonthEnum = "mar";
            break;
          case "04":
            selectedMonthEnum = "apr";
            break;
          case "05":
            selectedMonthEnum = "may";
            break;
          case "06":
            selectedMonthEnum = "jun";
            break;
          case "07":
            selectedMonthEnum = "jul";
            break;
          case "08":
            selectedMonthEnum = "aug";
            break;
          case "09":
            selectedMonthEnum = "sep";
            break;
          case "10":
            selectedMonthEnum = "oct";
            break;
          case "11":
            selectedMonthEnum = "nov";
            break;
          case "12":
            selectedMonthEnum = "dec";
            break;

          default:
            break;
        }
        return selectedMonthEnum; // Enum type - values :  ['jan', 'feb','mar', 'apr','may', 'jun','jul', 'aug','sep', 'oct','nov', 'dec']
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
     /** To lock/unlock the 'Next' button */
    locklist(ee) {
      if (ee) {
        this.isLocked = true;
      } else {
        this.isLocked = false;
      }
    },
    /** Navigation */
    cancel() {
        this.$router.push({
        path: `/payroll/run/${this.$route.params.entity_index}/lopsandrlopForOffPayroll`,
      });
    },

    save() {
      this.performAction("next");
    },

    async getEmployeeTemplate() {
      try {
      let data={
          le_id : this.le_id,
          financial_year: this.payrollYear,
          month: this.payrollMonth.slice(0, 3).toLowerCase()
        }
        let res = await this.fetch_template(data);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /***** BULK UPLOAD Previous implementation *****/
    
    async onUploadTemplate(event) {
      let fy = this.payrollYear;
      let formData = new FormData();
      formData.append("file", event);
      formData.append("le_id", this.le_id);
      formData.append("financial_year", fy);

      try {
        //let res = await this.act_upload_template(formData); // this is old api
        let res = await this.act_upload_template_new(formData); 
        //console.log(res);// this is new api
        if (res.status == 200 || res.status == 201) {
          this.popupMessage = res.data.message ? res.data.message : "";
          this.$refs.bulkFile.uploaded = true;
          this.$refs.bulkFile.uploading = false;
          this.showBulkUploadSuccessMsg = true;
          this.showErrorPopup = false;
        }
        // } else if(res.data.status != 200){
        //   //console.log("entryyyy");
        //   this.logSheetUrl = res.data.payload.error.payload;
        //   this.showErrorPopup = true;
        // }
      } catch (error) {
        this.showErrorPopup = true;
        this.logSheetUrl = error.payload.error.payload;
        this.logMessage = error.message;
      }
    },
    
   /***** BULK UPLOAD Current implementation *****/
    // async onUploadTemplate(res) {
    //   //console.log()
    //   try {
    //     if (res.data && res.data.status) {
    //       this.popupMessage = res.data.message ? res.data.message : "";
    //       this.showBulkUploadSuccessMsg = true;
    //     } else {
    //       this.toast = true;
    //       this.errmsg = res.message;
    //     }
    //   } catch (err) {
    //     this.$root._data.isSaving = false;
    //     this.toast = true;
    //     this.errmsg = err;
    //   }
    // },

    back() {
      this.showBulkUploadSuccessMsg = false;
      //this.$router.go(0);
    },
    setEmployee(val){
      this.selectedEmpData = val;
      this.getEmployeesSalaryComponents(val.empId);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/dashboard/content/_section.scss"; // Content Section

.paygrpsDiv {
  display: flex;
  cursor: pointer;
  padding: 40px 0px;

  span {
    color: #646464;
    font-size: 16px;
  }
  > :nth-child(n) {
    margin-right: 64px;
  }
  > :last-child {
    margin-right: 0px;
  }
}
.downloadTemplateButton{
  display: inline;
}
.paygrps-info {
  color: #646464;
  cursor: pointer;
  text-align: center;
  margin-top: 5px;
  b {
    font-size: 24px;
    font-weight: 500;
  }
}
.paygrp {
  background: #fbfbfb;
  width: 31%;
  height: 85px;
  border-radius: 2px;
  border: solid 1px #37c6c0;
  padding: 20px;
  text-align: center;
  display: flex;
  justify-content: inherit;
}
.alignPaygrp {
  padding: 20px;
  text-align: center;
}
.d-marginBottom {
  margin-bottom: 7px;
}
.line {
  border-bottom: 1px solid #c8c8c8;
  width: 100%;
  margin-bottom: 20px;
}
.uploadMethoRadio {
  margin-top: 30px;
  display: flex;
  margin-top: 2%;
}
.label {
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 8px;
  color: #6e6e6e;
}
.download-btn {
  margin-top: 2%;
}
.payslips {
  width: 37%;
}
.aligntext {
  text-align: center;
}
.lock-list {
  margin-top: 2%;
  display: flex;
  span {
    margin-top: 2px;
  }
}
.noofdays {
  input {
    border-radius: 4px;
    border: 1px solid #dadada;
    padding: 10px;
    width: 150px;
    height: 35px;
    transition: ease-in-out, width 0.35s ease-in-out;

    &:focus {
      outline: none;
      border: 2px solid #34c0be;
    }
  }
}
.month {
  margin-left: 0%;
}
.margin-top-30 {
  margin-top: 30px;
}
.margin-top-20 {
  margin-top: 20px;
}
.margin-top-10 {
  margin-top: 10px;
}
.customGrid1 {
  display: grid;
  grid-template-columns: 26% 26% 26%;
  grid-row-gap: 15px;
  grid-column-gap: 20px;
}
.customGrid2 {
  display: grid;
  grid-template-columns: 22% 22% 22%;
  grid-row-gap: 15px;
  grid-column-gap: 20px;
}
.margin-bottom-50 {
  margin-bottom: 50px;
}
.custom-width {
  width: 80%;
}
</style>

